import React, { useContext } from "react";
import { useParams } from "react-router-dom";
import Moment from "react-moment";
import moment from "moment";
import QRCode from "react-qr-code";
import {
  _t,
  getSystemSettings,
  getTaxIntegrationDetails,
} from "../../../../../functions/Functions";
import { useCustomHooks } from "../../../../../functions/Hooks";
//importing context consumer here
import { UserContext } from "../../../../../contexts/User";
import { SettingsContext } from "../../../../../contexts/Settings";
import { FoodContext } from "../../../../../contexts/Food";
import "react-toastify/dist/ReactToastify.css";
import { useTranslation } from "react-i18next";
import { BASE_URL } from "../../../../../BaseUrl";
import { useReceiptTranslation } from "../../../../../hooks/useReceiptTranslation";
import OrderBarcode from "../OrderBarcode";

//after order submit or settle
//All Receipt Control from this handle

export const OrderPrint = ({
  newOrder,
  theVat,
  theVatSettle,
  totalSettle,
  newSettings,
  cartTotal,
  returnMoneyUsd,
  loyaltyPoint,
  paidMoney,
  orderDetails,
  srbInvoiceNum,
  fbrInvoiceNum,
  serviceCharges,
  deliveryCharges,
  isSettle,
  taxType,
  selectedDeliveryType,
  selectedParty,
  selectedDeptTag,
  foodGroupsToPrint,
  selectedKot,
  cartSubTotal,
  customerPrint,
  component2Ref,
  barcodePrintRef = null,
  con_Kot,
}) => {
  const {
    generalSettings,
  } = useContext(SettingsContext);
  const {
    authUserInfo,
  } = useContext(UserContext);

  const {
    //food
    propertyGroupById,
    availableFoodGroupName,
  } = useContext(FoodContext);

  function bracketReplace(id) {
    const property_group_id = id && JSON.parse(id);
    return property_group_id[0];
  }
  const { order_id } = useParams();

  const { t } = useTranslation();
  const { roundFormatPrice, taxPercent, renderNetBill, showPropertyPrice, getSubtotalInclusiveSettle } = useCustomHooks();
  const { getDualText, getDualTextValue, getCombination, getDualTextKey, getTranlatedValue, renderItemName } = useReceiptTranslation();

  //print payment
  const printPayment = (payment) =>{
    const paymentType = payment && payment.map((item,index) => item.name + (index !== payment.length - 1 ? ", " : "")).join("");
    return paymentType
  }

  //item price for print
  const getPrintPrice = (item, variation = null) => {
    let price = variation
      ? parseFloat(variation?.food_with_variation_price)
      : parseInt(item.item.has_variation) === 1
      ? parseFloat(item.variation?.food_with_variation_price) * item.quantity
      : parseFloat(item.item.price) * item.quantity;
    const fixedPrice = parseInt(getSystemSettings(generalSettings, "fixed_inclusive_tax")) === 1;
    if((item.status === "foc" || item.status === "complimentory") && item.after_tax_price == 0){
      return 0
    }else if(fixedPrice && taxType === "inclusive" && isSettle && orderDetails.payment_type?.length === 1){
      return roundFormatPrice(price / (1 + (orderDetails.payment_type?.[0]?.tax_percent || orderDetails.branch?.branch_tax) / 100));
    } else if (taxType === "inclusive") {
      return roundFormatPrice(price / (1 + orderDetails.branch?.branch_tax / 100));
    } else {
      return roundFormatPrice(price);
    }
  };


  const qrPrint = (taxTaken,printText,InvoiceNum,taxImage,url="") =>{
    return(
      <div className="mb-1">
        <p className="print-text fk-print-text text-capitalize text-center">
          {taxTaken} Invoice Number {InvoiceNum}
        </p>
        <div className="mb-1">
          <div className="float-left">
            <img
              src={taxImage}
              height="80"
              alt={`${taxTaken} Invoice`}
            />
          </div>
          <div className="float-right">
            {(url || InvoiceNum) && (
              <QRCode value={url ? url : InvoiceNum} size="80" />
            )}
          </div>
          <div style={{ clear: "both" }}></div>
        </div>
        <p className="print-text fk-print-text text-center">
          {printText} <br></br> and win exciting prizes in
          draw.
        </p>
      </div>
    )
  }

  const getSubtotal = getSubtotalInclusiveSettle(newOrder,cartSubTotal,isSettle && orderDetails.payment_type?.length === 1);

  return (
    <>
      {/* Print bill */}
      <div className="d-none">
        <div ref={customerPrint}>
          {newOrder && (
            <div className="fk-print">
              <div className="container-fluid">
                <div className="row">
                  <div className="col-12">
                    {
                      (parseInt(getSystemSettings(generalSettings, "submit_print_header")) === 1 ? true : isSettle) ? (
                        <>
                          {
                            parseInt(getSystemSettings(generalSettings, "print_logo")) === 1 && (
                              <div className="mx-auto t-w-120" >
                                <img
                                  src={(orderDetails.branch && orderDetails.branch?.branch_logo) ? (BASE_URL + orderDetails.branch?.branch_logo) :
                                    `${getSystemSettings(
                                    generalSettings,
                                    "type_logo"
                                  )}`}
                                  alt="logo"
                                  className="w-100"
                                />
                              </div>
                            ) 
                          }
                          {
                            parseInt(getSystemSettings(generalSettings, "print_siteName")) === 1 && (
                              <div className="fk-print-text font-weight-bold text-center sm-text mt-2">
                                {getSystemSettings(generalSettings, "siteName")}
                              </div>
                            ) 
                          }
                          {
                            parseInt(getSystemSettings(generalSettings, "print_branchName")) === 1 && (
                              <div className="fk-print-text font-weight-bold text-uppercase text-center sm-text mt-2">
                                {orderDetails.branch &&
                                  (orderDetails.branch?.print_name ? orderDetails.branch.print_name :
                                  orderDetails.branch.name)}
                              </div>
                            ) 
                          }
                          {
                            parseInt(getSystemSettings(generalSettings, "print_branchAddress")) === 1 && (
                              <p className="mb-0 sm-text fk-print-text text-center text-capitalize">
                                {orderDetails?.branch &&
                                  orderDetails.branch.address}
                              </p>
                            )
                          }
                          {
                            parseInt(getSystemSettings(generalSettings, "print_branchPhone")) === 1 &&(
                              <p className="mb-0 sm-text fk-print-text text-center text-capitalize">
                                {getDualTextValue("call", ((orderDetails?.branch && orderDetails.branch?.phn_no) ?? ""), ": ")}
                              </p>
                            )
                          }
                          {
                            parseInt(getSystemSettings(generalSettings, "print_heading")) === 1 && (
                              <p className="mb-0 sm-text fk-print-text text-center">
                                {(orderDetails.branch && orderDetails.branch?.sntn_no) ? 
                                orderDetails.branch.sntn_no : getSystemSettings(generalSettings, "type_print_heading")}
                              </p>
                            )
                          }
                        </>
                      ) : ""
                    }
                    {orderDetails && orderDetails.table !== null && orderDetails.table?.length > 0 && (
                      <p className="mb-0 sm-text fk-print-text text-capitalize text-center">
                        {getDualTextValue("Table #", orderDetails?.table_name, " : ")}
                      </p>
                     )
                    }
                    {
                      !navigator.onLine && (
                        <p className="mb-0 sm-text fk-print-text text-center text-capitalize">
                          {getDualTextValue("Offline")}
                        </p>
                      )
                    }

                   <div className = "myBorderTopCustomer pt-1 d-flex align-items-center justify-content-between"> 
                      <span className="fk-print-text text-uppercase new-sm-text fk-print-text--bold mr-1">
                        {getDualTextValue(getSystemSettings(generalSettings, "token_text"),orderDetails?.token && orderDetails.token.id, " - ")}
                      </span>
                      {
                        parseInt(getSystemSettings(generalSettings, "order_no")) === 1 && (
                          <span className="fk-print-text text-uppercase new-sm-text fk-print-text--bold">
                            {getDualTextValue("Invoice No",orderDetails?.order_No && orderDetails.order_No, " - ")}
                          </span>
                        )
                      }
                   </div> 

                    {
                      getSystemSettings(generalSettings, "print_orderParty") === "both" && (
                        <p className="mb-0 fk-print-text text-capitalize print-text text-center">
                          {getCombination(orderDetails && selectedDeliveryType &&
                            selectedDeliveryType.name, selectedParty && selectedParty?.name)}
                        </p>
                      )
                    }
                    {
                      getSystemSettings(generalSettings, "print_orderParty") === "order_type" && (
                        <p className="mb-0 fk-print-text text-capitalize print-text text-center">
                          {getCombination(orderDetails && selectedDeliveryType && selectedDeliveryType.name)}
                        </p>
                      )
                    }
                    {
                      getSystemSettings(generalSettings, "print_orderParty") === "party" && (
                        <p className="mb-0 fk-print-text text-capitalize print-text text-center">
                          {getCombination(orderDetails && selectedParty && selectedParty?.name)}
                        </p>
                      )
                    }
                    <p className="mb-0 mt-0 print-text fk-print-text text-capitalize text-center">
                      {getDualText("Customer Copy")}
                    </p>
                    {/* <p className="mb-0 print-text fk-print-text text-capitalize">
                      {_t(t("Vat reg"))}: {_t(t("Applied"))}
                    </p> */}
                    <div className="myBorder mb-2"></div>
                      {
                        (orderDetails.newCustomerInfo?.name) && (
                          <p className="mb-1 print-text fk-print-text text-capitalize">
                            {/* {_t(t("Customer Name"))}:{" "}
                            {orderDetails.newCustomerInfo && orderDetails.newCustomerInfo?.name} */}
                            {getDualTextValue("Customer Name", orderDetails.newCustomerInfo && orderDetails.newCustomerInfo?.name, ": ")}
                          </p>
                        )
                      }
                      {
                      (orderDetails.newCustomerInfo?.phn_no) && (
                        <p className="mb-1 print-text fk-print-text text-capitalize">
                          {/* {_t(t("Phone #"))}:{" "}
                          {orderDetails.newCustomerInfo && orderDetails.newCustomerInfo?.phn_no} */}
                          {getDualTextValue("Phone #", orderDetails.newCustomerInfo && orderDetails.newCustomerInfo?.phn_no, ": ")}
                        </p>
                      )
                      }
                      {
                      (orderDetails.newCustomerInfo?.alt_phn_no) && (
                        <p className="mb-1 print-text fk-print-text text-capitalize">
                          {getDualTextValue("Alt Phone #", orderDetails.newCustomerInfo && orderDetails.newCustomerInfo?.alt_phn_no, ": ")}
                        </p>
                      )
                      }
                      {
                        (orderDetails.newCustomerInfo?.ntn_no) && (
                          <p className="mb-1 print-text fk-print-text text-capitalize">
                            {getDualTextValue("NTN No", orderDetails.newCustomerInfo && orderDetails.newCustomerInfo?.ntn_no, ": ")}
                          </p>
                        )
                      }
                      {
                      (orderDetails.newCustomerInfo?.email) && (
                        <p className="mb-1 print-text fk-print-text text-capitalize">
                          {getDualTextValue("Email", orderDetails.newCustomerInfo && orderDetails.newCustomerInfo?.email, ": ")}
                        </p>
                      )
                      }
                      {
                      (orderDetails.newCustomerInfo?.nearest_landmark) && (
                        <p className="mb-1 print-text fk-print-text text-capitalize">
                          {getDualTextValue("Nearest Landmark", orderDetails.newCustomerInfo && orderDetails.newCustomerInfo?.nearest_landmark, ": ")}
                        </p>
                      )
                      }
                      {(orderDetails.newCustomerInfo?.address || orderDetails.customer?.address) && (
                        <p className="mb-1 print-text fk-print-text text-capitalize">
                          {/* {_t(t("Address "))}:{" "}
                          {orderDetails.newCustomerInfo && orderDetails.newCustomerInfo?.address} */}
                          {getDualTextValue("Address", orderDetails.newCustomerInfo && orderDetails.newCustomerInfo?.address, ": ")}
                        </p>
                      )}
                      {orderDetails?.note_to_rider && orderDetails?.note_to_rider !== "" && 
                        <p className="mb-1 print-text fk-print-text text-capitalize mx-1">
                          {getDualTextValue("Rider Note",orderDetails.note_to_rider, ": ")}
                        </p>    
                      }
                      <p className="mb-1 print-text fk-print-text text-capitalize">
                        {getDualTextValue("ref no", ((orderDetails.newCustomerInfo && orderDetails.newCustomerInfo?.ref_no) ?? ""), " : ")}
                      </p>

                    <p className="mb-0 print-text fk-print-text text-capitalize">
                      {/* {getDualText("Date")}: {" "} <Moment format="LL">{new Date()}</Moment>
                      {", "}
                      {orderDetails.token && (
                        <Moment format="LT">{orderDetails.token?.time}</Moment>
                      )} */}
                      {getDualTextValue("Date", moment(new Date()).format("MMMM DD, YYYY") + ", " + moment(orderDetails.token?.time).format("hh:mm A"), ": ")}
                    </p>
                    {
                      orderDetails.is_advance_booking ? (
                        <p className="mb-0 print-text fk-print-text text-capitalize">
                          {getDualTextValue("Delivery Date", moment(new Date(orderDetails.pre_order_date)).format("MMMM DD, YYYY , hh:mm A"), ": ")}
                        </p>
                      ) : ""
                    }
                    
                    {orderDetails && orderDetails.waiter !== null ? (
                      <p className="mb-0 print-text fk-print-text text-capitalize">
                        {/* {_t(t("Waiter Name"))}: {orderDetails.waiter.name} */}
                        {getDualTextValue("Waiter Name", orderDetails.waiter.name, ": ")}
                      </p>
                      ) : (
                        ""
                    )}

                    {
                      selectedDeliveryType?.name === "Dine-In" && (
                        <p className="mb-1 print-text fk-print-text text-capitalize">
                          {/* {_t(t("guests"))}:{" "}
                          {orderDetails && orderDetails.total_guest} */}
                          {getDualTextValue("guests", orderDetails.total_guest, ": ")}
                        </p>
                      )
                    }

                    {parseInt(getSystemSettings(generalSettings, "print_paymentType")) === 1 && (
                      isSettle === 1 ? (
                        <p className="mb-0 print-text fk-print-text text-capitalize lg-text">
                          {orderDetails?.payment_type &&
                            printPayment(orderDetails?.payment_type)}{" "}
                          - {" "}
                          {getDualTextValue("PAID")}
                        </p>
                      ) : (
                        <p className="mb-0 print-text fk-print-text text-capitalize lg-text">
                          {getDualTextValue("Un PAID")}
                        </p>
                      )
                    )}
                    <table className="w-100 mb-0 table-borderless">
                      <thead>
                        <tr>
                          <th
                          scope="col"
                          className="fk-print-text print-text text-capitalize"
                          >
                          {/*<div className="d-flex flex-wrap align-items-center">
                           <span style={{width:"10.5%"}} className="d-inline-block">
                            {_t(t("qty"))}
                            </span>
                            <span style={{width:"82%"}} className="d-inline-block">
                            {_t(t("item"))}
                             </span>
                            </div>*/}
                            {/* {getDualText("qty      item")} */}
                            <div className="d-flex flex-wrap align-items-center">
                              <span style={{width:"12%"}} className="d-inline-block fk-print-text print-text">
                                {getDualText("qty")}
                              </span>
                              <span style={{width:"82%"}} className="text-break text-preline d-inline-block ml-2 fk-print-text print-text">
                                {getDualText("item")} 
                              </span>
                            </div>
                          </th>
                          <th
                          scope="col"
                          className="fk-print-text print-text text-capitalize text-right"
                          >      
                            {getDualText("T.price")}
                          </th>
                        </tr>
                      </thead>
                      <tr className="myBorderBottom mb-1"></tr>
                      <tbody>
                        {newOrder.map((printItem, printItemIndex) => {
                          return (
                            <>
                              <tr key={printItemIndex}>
                                <td className="text-capitalize">
                                  <div className="d-flex flex-wrap align-items-center">
                                    <span style={{width:"12%"}} className="d-inline-block fk-print-text print-text">
                                      {printItem.quantity}{" "}
                                    </span>
                                    <span style={{width:"82%"}} className="text-break text-preline d-inline-block ml-2 fk-print-text print-text">
                                      {renderItemName(printItem)}
                                    </span>
                                  </div>   
                                </td>
                                <td className="fk-print-text print-text text-capitalize text-right">
                                  {getPrintPrice(printItem)}
                                </td>
                              </tr>
                            
                              {/* properties */}
                              {printItem.properties &&
                                printItem.properties.length > 0 &&
                                  printItem.properties.map((propertyName, ind) => {
                                      return (
                                        <tr key={ind}>
                                          <td className="fk-print-text print-text text-capitalize ">
                                            <span className="fk-print-text text-capitalize print-text d-inline-block " style={{marginLeft:"13%"}}>
                                              {getTranlatedValue(`-${printItem.quantity}${propertyName.quantity > 1 ? "*" +
                                                  propertyName.quantity
                                                : ""} ${propertyName.item.name}`, propertyName.item?.translated_name && `  ${propertyName.item?.translated_name} `)}
                                            </span>
                                          </td>
                                          <td className="fk-print-text print-text text-capitalize text-right">
                                            {(printItem.status === "foc" || printItem.status === "complimentory") && printItem.after_tax_price == 0 ?
                                              0 : showPropertyPrice(
                                              (printItem.quantity * propertyName.quantity),
                                              propertyName.item.extra_price,
                                              orderDetails.payment_type?.[0]?.tax_percent || orderDetails.branch?.branch_tax
                                            )}
                                          </td>
                                      </tr>
                                    );
                                  }
                                )}
                            </>
                          );
                        })}
                      </tbody>
                    </table>
                    <div className="myBorder mb-1"></div>
                    <table className="w-100 mb-0 table-borderless">
                      <tbody>
                        <tr>
                          <th className="py-0 pb-1 fk-print-text print-text text-capitalize">
                            <span className="d-block p-0 m-0">{getDualTextValue("total")}</span>
                          </th>
                          <td className="py-0 pb-1 fk-print-text print-text text-capitalize text-right">
                            {getSubtotal}
                          </td>
                        </tr>
                      </tbody>
                    </table>

                    <>
                      {orderDetails.scheme && parseFloat(orderDetails.scheme.discount_amount) > 0 ? (
                          <table className="w-100 mb-0 table-borderless">
                            <tbody>
                            <tr>
                              <th className="py-0 pb-1 fk-print-text print-text text-capitalize">
                                <span className="d-block">
                                  {getDualTextKey("discount", (orderDetails?.scheme && (orderDetails.scheme.discount_type == "percentage" || orderDetails.scheme.open_discount) && orderDetails.discount ? `(${orderDetails.discount}%)` : ""))}
                                <span className="sm-text ml-2">
                                  ({orderDetails?.scheme?.scheme_name})
                                </span>
                                </span>
                              </th>
                              {orderDetails && (
                                <td className="py-0 pb-1 fk-print-text print-text text-capitalize text-right">
                                  {
                                    orderDetails.scheme &&
                                    `${roundFormatPrice(parseFloat(orderDetails.scheme.discount_amount))}`
                                  }
                                </td>
                              )}
                            </tr>
                              {/* {
                                orderDetails?.scheme && orderDetails.scheme?.scheme_name ? (
                                  <tr>
                                    <td className="py-0 pb-1 fk-print-text print-text text-capitalize">
                                      <span className="sm-text">
                                        {orderDetails.scheme.scheme_name}
                                      </span>
                                    </td>
                                    <td className="py-0 pb-1"></td>
                                  </tr>
                                ) : ""
                              } */}
                              <tr>
                                <th className="py-0 pb-1 fk-print-text print-text text-capitalize">
                                  {getDualText("Net Total")}
                                </th>
                                <td className="py-0 pb-1 fk-print-text print-text text-capitalize text-right">
                                  {roundFormatPrice(
                                    Math.max(
                                      0,
                                      parseFloat(getSubtotal || 0) -
                                        parseFloat(orderDetails.scheme.discount_amount || 0)
                                    )
                                  )}
                                </td>
                              </tr>
                             
                            </tbody>
                          </table>
                        ) : ""
                      }

                      {deliveryCharges > 0 && (
                          <table className="w-100 mb-0 table-borderless">
                            <tbody>
                              <tr>
                                <th className="py-0 pb-1 fk-print-text print-text text-capitalize">
                                  {getDualText("D.Charge")}
                                </th>

                              {orderDetails && (
                                <td className="py-0 pb-1 fk-print-text print-text text-capitalize text-right">
                                  {roundFormatPrice(deliveryCharges)}
                                </td>
                              )}
                            </tr>
                          </tbody>
                        </table>
                      )}

                      {serviceCharges > 0 && (
                          <table className="w-100 mb-0 table-borderless">
                            <tbody>
                              <tr>
                                <th className="py-0 pb-1 fk-print-text print-text text-capitalize">
                                  {getDualText("S.Charges")}
                                  {orderDetails &&
                                    "(" + orderDetails.branch.service_fees + "%)"}
                                </th>

                                {orderDetails && (
                                  <td className="py-0 pb-1 fk-print-text print-text text-capitalize text-right">
                                    {roundFormatPrice(
                                      serviceCharges
                                    )}
                                  </td>
                                )}
                              </tr>
                            </tbody>
                          </table>
                        )
                      }
                    </>

                    {
                      isSettle === 0 ?
                       theVat > 0 && (
                        <table className="w-100 mb-0 table-borderless">
                          <tbody>
                            {getSystemSettings(generalSettings, "vat_system") ===
                            "igst" ? (
                              <tr>
                                <th className="py-0 pb-1 fk-print-text print-text text-uppercase">                                  
                                  {getDualTextKey(orderDetails.branch?.print_tax,`(${newSettings !== null ? parseInt(newSettings.vat) : orderDetails.branch.branch_tax}%)`)}
                                </th>
                                <td className="py-0 pb-1 fk-print-text print-text text-capitalize text-right">
                                  {roundFormatPrice(theVat)}
                                </td>
                              </tr>
                            ) : getSystemSettings(
                                generalSettings,
                                "vat_system"
                              ) === "cgst" ? (
                              <>
                                <tr>
                                  <th className="py-0 pb-1 fk-print-text print-text">
                                    CGST(
                                    {getSystemSettings(generalSettings, "cgst")}
                                    %)
                                  </th>
                                  <td className="py-0 pb-1 fk-print-text print-text text-capitalize text-right">
                                    {roundFormatPrice(
                                      Math.max(
                                        0,
                                        parseFloat(cartSubTotal || 0) -
                                          parseFloat(orderDetails?.scheme?.discount_amount || 0)
                                      ) *
                                        (parseFloat(
                                          getSystemSettings(
                                            generalSettings,
                                            "cgst"
                                          )
                                        ) / 100)
                                    )}
                                  </td>
                                </tr>
                                <tr>
                                  <th className="py-0 pb-1 fk-print-text print-text">
                                    SGST(
                                    {getSystemSettings(generalSettings, "sgst")}
                                    %)
                                  </th>
                                  <td className="py-0 pb-1 fk-print-text print-text text-capitalize text-right">
                                    {roundFormatPrice(
                                      Math.max(
                                        0,
                                        parseFloat(cartSubTotal || 0) -
                                          parseFloat(orderDetails?.scheme?.discount_amount || 0)
                                      ) *
                                        (parseFloat(
                                          getSystemSettings(
                                            generalSettings,
                                            "sgst"
                                          )
                                        ) / 100)
                                    )}
                                  </td>
                                </tr>
                              </>
                            ) : (
                              <tr>
                                <th className="py-0 pb-1 fk-print-text print-text text-uppercase">
                                  {orderDetails.branch?.print_tax}
                                  ({newSettings !== null ? newSettings.tax : orderDetails.branch.branch_tax}
                                  %)
                                </th>
                                <td className="py-0 pb-1 fk-print-text print-text text-capitalize text-right">
                                  {roundFormatPrice(theVat)}
                                </td>
                              </tr>
                            )}
                          </tbody>
                        </table>
                      )
                      :
                       theVatSettle > 0 && (
                        <table className="w-100 mb-0 table-borderless">
                          <tbody>
                            {getSystemSettings(generalSettings, "vat_system") ===
                            "igst" ? (
                              <tr>
                                <th className="py-0 pb-1 fk-print-text print-text text-uppercase">
                                  {getDualTextKey(orderDetails.branch?.print_tax, theVatSettle > 0  && `(${taxPercent(getSubtotal,theVatSettle,orderDetails.scheme.discount_amount)}%)`)}
                                </th>
                                <td className="py-0 pb-1 fk-print-text print-text text-capitalize text-right">
                                  {roundFormatPrice(theVatSettle)}
                                </td>
                              </tr>
                            ) : getSystemSettings(
                                generalSettings,
                                "vat_system"
                              ) === "cgst" ? (
                              <>
                                <tr>
                                  <th className="py-0 pb-1 fk-print-text print-text">
                                    CGST(
                                    {getSystemSettings(generalSettings, "cgst")}
                                    %)
                                  </th>
                                  <td className="py-0 pb-1 fk-print-text print-text text-capitalize text-right">
                                    {roundFormatPrice(
                                      Math.max(
                                        0,
                                        parseFloat(cartSubTotal || 0) -
                                          parseFloat(orderDetails?.scheme?.discount_amount || 0)
                                      ) *
                                        (parseFloat(
                                          getSystemSettings(
                                            generalSettings,
                                            "cgst"
                                          )
                                        ) /
                                          100)
                                    )}
                                  </td>
                                </tr>
                                <tr>
                                  <th className="py-0 pb-1 fk-print-text print-text">
                                      SGST(
                                      {getSystemSettings(generalSettings, "sgst")}
                                      %)
                                  </th>
                                  <td className="py-0 pb-1 fk-print-text print-text text-capitalize text-right">
                                    {roundFormatPrice(
                                      Math.max(
                                        0,
                                        parseFloat(cartSubTotal || 0) -
                                          parseFloat(orderDetails?.scheme?.discount_amount || 0)
                                      ) *
                                        (parseFloat(
                                          getSystemSettings(
                                            generalSettings,
                                            "sgst"
                                          )
                                        ) / 100)
                                    )}
                                  </td>
                                </tr>
                              </>
                            ) : (
                              <tr>
                                <th className="py-0 pb-1 fk-print-text print-text text-uppercase">
                                  {orderDetails.branch?.print_tax}
                                  ({newSettings !== null ? newSettings.tax : orderDetails.payment_tax[orderDetails.payment_type[0].name]}
                                  %)
                                </th>
                                <td className="py-0 pb-1 fk-print-text print-text text-capitalize text-right">
                                  {roundFormatPrice(theVatSettle)}
                                </td>
                              </tr>
                            )}
                          </tbody>
                        </table>
                      )
                    }

                    {loyaltyPoint.redeemPoints > 0 && (
                        <table className="w-100 mb-0 table-borderless">
                            <tbody>
                              <tr>
                                <th className="py-0 pb-1 fk-print-text print-text text-capitalize">
                                  {getDualText("Redeem Points")}
                                </th>
                                {orderDetails && (
                                  <td className="py-0 pb-1 fk-print-text print-text text-capitalize text-right">
                                    {roundFormatPrice(loyaltyPoint.redeemPoints)}
                                  </td>
                                )}
                              </tr>
                            </tbody>
                        </table>
                      )
                    }

                    {orderDetails?.payment_type && orderDetails.payment_type?.length > 1 && (
                      <>
                        <div className="myBorder mb-1"></div>
                        <table className="w-100 mb-0 table-borderless">
                          <tbody>
                              {orderDetails?.payment_type.map((item, ind)=>{
                                return (
                                  <tr key={ind}>
                                    <th className="py-0 pb-1 fk-print-text print-text text-capitalize">
                                      {_t(t(item.name))}
                                    </th>
                                    <td className="py-0 pb-1 fk-print-text print-text text-capitalize text-right">
                                      {_t(t(item.bill_amount))}
                                    </td>
                                  </tr>
                                )
                              }) 
                            }
                          </tbody>
                        </table>
                      </>
                    )}

                    <div className="myBorder mb-1"></div>
                    <table className="w-100 mb-0 table-borderless">
                      <tbody>
                        {(orderDetails?.branch?.fbr_integration === 1 || orderDetails?.branch?.cbr_integration || orderDetails?.branch?.pbr_integration === 1 || orderDetails?.branch?.sbr_integration === 1) && 
                          (fbrInvoiceNum || srbInvoiceNum?.number) && paidMoney > 0 && (
                            <tr>
                              <th className="py-0 pb-1 fk-print-text print-text text-capitalize">
                                {getDualText("POS Invoice Fee")}
                              </th>
                              <td className="py-0 pb-1 fk-print-text print-text text-capitalize text-right">
                                {_t(t("1.00"))}
                              </td>
                            </tr>
                          )}
                        {orderDetails.is_advance_booking && Number(orderDetails.advance_amount) > 0 ? (
                          <tr>
                            <th className="py-0 pb-1 fk-print-text print-text text-capitalize">
                              {getDualText("Advance Amount")}
                            </th>
                            <td className="py-0 pb-1 fk-print-text print-text text-capitalize text-right">
                              {roundFormatPrice(orderDetails.advance_amount)}
                            </td>
                          </tr>
                        ) : ""
                        }
                        <tr>
                          <th className="py-0 pb-1 fk-print-text print-text text-capitalize">
                            {getDualText(orderDetails.is_advance_booking && Number(orderDetails.advance_amount) > 0 ? "Remaining Amount" : "grand total")}
                          </th>
                          <td className=" py-0 pb-1 fk-print-text print-text text-capitalize text-right">
                            {
                            isSettle === 0 ? (  
                            paidMoney > 0 && (orderDetails?.branch?.fbr_integration || orderDetails?.branch?.cbr_integration || orderDetails?.branch?.pbr_integration === 1 || orderDetails?.branch?.sbr_integration) && 
                            (fbrInvoiceNum || srbInvoiceNum?.number)
                              ? roundFormatPrice(cartTotal + 1)
                              : roundFormatPrice(cartTotal))
                              : roundFormatPrice(totalSettle)
                            }
                          </td>
                        </tr>
                        <tr>
                          <th className="py-0 pb-1 fk-print-text print-text text-capitalize">
                            {getDualText("Paid Amount")}
                          </th>
                          <td className="py-0 pb-1 fk-print-text print-text text-capitalize text-right">
                            {roundFormatPrice(paidMoney)}
                          </td>
                        </tr>
                        <tr>
                          <th className="py-0 pb-1 fk-print-text print-text text-capitalize">
                            {getDualText("Return Amount")}
                          </th>
                          <td className="py-0 pb-1 fk-print-text print-text text-capitalize text-right">
                            {roundFormatPrice(returnMoneyUsd)}
                          </td>
                        </tr>
                        {parseFloat(orderDetails?.order_tip) > 0 && (
                            <tr>
                              <th className="py-0 pb-1 fk-print-text print-text text-capitalize">
                                {getDualText("Order Tip")}
                              </th>
                              <td className="py-0 pb-1 fk-print-text print-text text-capitalize text-right">
                                {roundFormatPrice(orderDetails.order_tip)}
                              </td>
                            </tr>
                          )
                        }
                        {loyaltyPoint.availablePoints > 0 && (
                            <tr>
                              <th className="py-0 pb-1 fk-print-text print-text text-capitalize">
                                {getDualText("Available Points")}
                              </th>
                              {orderDetails && (
                                <td className="py-0 pb-1 fk-print-text print-text text-capitalize text-right">
                                  {roundFormatPrice(loyaltyPoint.availablePoints)}
                                </td>
                              )}
                            </tr>
                          )
                        }
                        {loyaltyPoint.earnedPoints > 0 && (
                            <tr>
                              <th className="py-0 pb-1 fk-print-text print-text text-capitalize">
                                {getDualText("Earned Points")}
                              </th>
                              {orderDetails && (
                                <td className="py-0 pb-1 fk-print-text print-text text-capitalize text-right">
                                  {roundFormatPrice(loyaltyPoint.earnedPoints)}
                                </td>
                              )}
                            </tr>
                          )
                        }
                      </tbody>
                    </table>
                    {parseInt(getSystemSettings(generalSettings, "fixed_inclusive_tax")) !== 1 && parseInt(getSystemSettings(generalSettings,"view_cash_card")) === 1 && !isSettle && (
                      <React.Fragment>
                        <div className="myBorder mt-1"></div>
                        {renderNetBill( cartTotal, getSubtotal, theVat, orderDetails.scheme.discount_amount, orderDetails.branch, "cash", "Cash Net Bill")}
                        
                        {renderNetBill( cartTotal, getSubtotal, theVat, orderDetails.scheme.discount_amount, orderDetails.branch, "card", "Card Net Bill")}
                      </React.Fragment> 
                     ) 
                    }

                    {(() => {
                      const taxDetails = paidMoney > 0 ? getTaxIntegrationDetails(orderDetails?.branch, fbrInvoiceNum, srbInvoiceNum?.number, srbInvoiceNum?.url) : null;
                      if (taxDetails) {
                        const invNum = fbrInvoiceNum || (srbInvoiceNum?.number);
                        return qrPrint(taxDetails.taxTaken, taxDetails.printText, invNum, taxDetails.taxImage, taxDetails.qrValue);
                      }
                      return null;
                    })()}

                    {
                      isSettle && (orderDetails.branch?.feedback_url || 
                      parseInt(getSystemSettings(generalSettings, "is_feedback")) === 1) ? (
                        <>
                          <div className="myBorder mt-1"></div>
                          <div className="text-center mt-2" style={{ transform: 'scale(0.85)', transformOrigin: 'center center'}}>
                            {
                              parseInt(getSystemSettings(generalSettings, "is_feedback")) === 1 ? (
                                orderDetails.token?.hash_id && (<QRCode value={window.location.origin + "/feedback/" + orderDetails.token?.hash_id} size="116"/>)
                              ) : (
                                orderDetails.branch.feedback_url && (
                                  <QRCode value={orderDetails.branch.feedback_url + "?uid=" + (orderDetails.token && (orderDetails.token?.order_id))} size="116"/>
                                )
                              )
                            }
                          </div>
                          <div style={{ clear: "both" }}></div>
                          <p className="print-text fk-print-text text-center mt-0 mb-1">
                            {getDualText("Your Feedback Feeds Our Improvement – Scan to Help!")}
                          </p>
                        </>
                      ) : ""
                    }  

                    <div className="myBorder mt-1"></div>                    
                    <p className="my-0 text-preline sm-text fk-print-text text-center text-capitalize">
                      {getSystemSettings(generalSettings, "type_print_footer")}
                    </p>
                    <p className="my-0 sm-text fk-print-text fk-print-text--bold text-capitalize text-center">
                      {_t(t("bill prepared by"))}:{" "}
                      {authUserInfo?.details &&
                        authUserInfo.details.name}
                    </p>
                    <p className="my-0 sm-text fk-print-text fk-print-text--bold text-capitalize text-center">
                      {_t(t(getSystemSettings(generalSettings, "print_bill_footer")))}
                    </p>
                    <p className="my-0 fk-print-text text-capitalize print-text fk-print-text--bold">
                      {_t(t("Print Time"))}: {" "}
                      {orderDetails?.token && (
                        <Moment format="LLL">{new Date()}</Moment>
                      )}
                    </p>
                  </div>
                </div>
              </div>
            </div>
          )}
        </div>
      </div>

      {/* Print bill kitchen */}
      <div className="d-none">
        <div ref={component2Ref}>
          {/* {newOrder && ( */}
          <div className="fk-print">
            <div className="container-fluid">
              <div className="row">
                <div className="col-12 mt-3">
                  <div className="fk-print-text fk-print-text--bold text-uppercase text-center mt-3 lg-text">
                    {getDualTextValue(getSystemSettings(generalSettings, "token_text"),orderDetails?.token && orderDetails.token?.id, " - ")}
                  </div>
                  {
                    parseInt(getSystemSettings(generalSettings, "order_no")) === 1 && (
                      <div className="fk-print-text fk-print-text--bold text-uppercase text-center mt-1 lg-text">
                        {getDualTextValue("Invoice No",orderDetails?.order_No ?? "", " - ")}
                      </div>
                    )
                  }
                  <p className="mb-0 fk-print-text text-capitalize lg-text fk-print-text--bold">
                    {orderDetails && selectedDeptTag && selectedDeptTag.name}
                  </p>
                  <p className="mb-0 mt-0 fk-print-text fk-print-text--bold text-capitalize text-center">
                    {_t(t(getSystemSettings(generalSettings, "kot_header")))}
                    {foodGroupsToPrint &&
                    Object.values(foodGroupsToPrint)?.length &&
                    Object.values(foodGroupsToPrint)[0][0] &&
                    Object.values(foodGroupsToPrint)[0][0].item?.kot &&
                    Object.values(foodGroupsToPrint)[0][0].item.kot !== "No" ? (
                      <span>
                        {" "}
                        ({_t(t(Object.values(foodGroupsToPrint)[0][0].item.kot))})
                      </span>
                    ) : (
                      ""
                    )}
                  </p>
                  <p className="my-0 fk-print-text text-capitalize text-center">
                    {selectedDeliveryType &&
                      selectedParty?.name + " - ref no : " +
                        (orderDetails?.newCustomerInfo && orderDetails.newCustomerInfo?.ref_no
                          ? orderDetails.newCustomerInfo.ref_no
                          : "")}
                  </p>
                  {orderDetails && orderDetails.table !== null && orderDetails.table?.length > 0 ? (
                    <p className="my-0 fk-print-text text-capitalize text-center">
                      {getDualTextValue("Table #", orderDetails.table_name, " : ")}
                    </p>
                  ) : (
                    ""
                  )}

                  {orderDetails && orderDetails.waiter !== null ? (
                    <p className="my-0 fk-print-text text-capitalize text-center">
                      {getDualTextValue("Waiter Name", orderDetails.waiter.name, ": ")}
                    </p>
                    ) : (
                      ""
                  )}

                  { 
                    orderDetails.newCustomerInfo && (orderDetails.newCustomerInfo?.name) && (
                    <p className="my-0 fk-print-text text-capitalize text-center">
                      {getDualTextValue("Customer Name", orderDetails.newCustomerInfo?.name, ": ")}
                    </p>
                    )
                  }

                  {con_Kot?.current && con_Kot?.current !== "" &&
                    <p className="my-0 fk-print-text fk-print-text--bold text-capitalize text-center border border-dark">
                      {con_Kot.current}
                    </p>
                  }

                  <table className="w-100 mb-0 table-borderless">
                    <tbody>
                      <tr className="myBorderPrintBottom mb-1">
                        <th
                        className="fk-print-text text-capitalize"
                        >
                          <div className="d-flex flex-wrap align-items-center">
                            <span className="lg-text fk-print-text--bold fk-print-text print_w-20" >
                              {getDualText("Qty")}
                            </span>
                    
                            <span className="lg-text fk-print-text--bold fk-print-text print_w-80" >
                              {getDualText("Item")}
                            </span> 
                          </div>
                        </th>
                      </tr>
                      {foodGroupsToPrint &&
                        Object.keys(foodGroupsToPrint)?.length &&
                        Object.keys(foodGroupsToPrint).map(
                          (theGrp, grpIndex) => {
                            return (
                              <>
                                <tr key={grpIndex}>
                                  <td className="text-center">
                                    <div
                                      className={`${
                                        // grpIndex === 0
                                          // ? 
                                          "myBorder"
                                          // : "myBorderBottom"
                                      } lg-text fk-print-text--bold fk-print-text text-center mb-1`}
                                    >
                                      {getTranlatedValue(theGrp, availableFoodGroupName[theGrp]?.translated_name)}
                                    </div>
                                  </td>
                                </tr>
                            
                                {foodGroupsToPrint[theGrp].map(
                                  (printItem, ind) => {
                                    return (
                                      <tr key={ind}>
                                        <th className="fk-print-text text-capitalize">
                                          {order_id ? (
                                            <div className="d-block w-100 p-0 mb-1">
                                              <span className="lg-text fk-print-text--bold fk-print-text pl-1">
                                                {printItem.reason  ||
                                                  printItem.status
                                                  ? getDualText("CANCELLED")
                                                  : getDualText("ADDED")}
                                                {":"}
                                              </span>
                                              {printItem.reason ? (
                                                <span className="lg-text fk-print-text--bold fk-print-text pl-1">
                                                  {" "}
                                                  (Reason: {printItem.reason})
                                                </span>
                                              ) : null}
                                            </div>
                                          ) : null}
                                        {printItem.item.is_special != "1" || !printItem.hasOwnProperty('property') ? (
                                          <>
                                            <div className="d-flex flex-wrap">
                                              <span className="print_w-20 ml-1 pl-1">
                                                {printItem.quantity}
                                              </span>
                                              <span className="lg-text fk-print-text--bold fk-print-text print_w-80 p-0 m-0">
                                                {renderItemName(printItem, true)}
                                                {/* {printItem.item.name}{" "} */}
                                                {/* {parseInt(
                                                  printItem.item.has_variation
                                                ) === 1 &&
                                                printItem.variation && (
                                                  <span className="lg-text fk-print-text--bold fk-print-text mr-1" >
                                                    ({printItem.variation.variation_name})
                                                  </span>
                                                )} */}
                                                {/* <span className="text-preline text-break lg-text fk-print-text--bold fk-print-text pl-1 ml-2" >
                                                  {printItem.comments ? `(${printItem.comments})` : ""}
                                                </span> */}
                                              </span>
                                              
                                            </div>
                                          
                                            {printItem.item.item_description ? (
                                              <div className="d-flex flex-wrap align-items-center">
                                              <span className="print_w-20"></span>
                                                <span className="text-preline d-inline-block lg-text ml-1 fk-print-text--bold fk-print-text print_w-80">
                                                  {
                                                    printItem.item.item_description
                                                  }
                                                </span>
                                              </div>
                                            ) : null}
                                            {/* properties */}
                                            {printItem.properties &&
                                              printItem.properties.length > 0 ? (
                                                <div className="pl-2 d-flex flex-wrap align-items-center">
                                                  {printItem.item.property_groups.map(
                                                    (propertyGrpName) => {
                                                      let theGroup = propertyGroupById && propertyGroupById[propertyGrpName]

                                                        let propertWithGroup = []
                                                        printItem.properties.forEach(prop => {
                                                          const propertyGroupIds = JSON.parse(prop.item.property_group_id);
                                                          if(propertyGroupIds.includes(propertyGrpName)){
                                                            propertWithGroup.push(prop);
                                                          }
                                                        });
                                                      
                                                        return (
                                                          <>
                                                          {
                                                            //IsGroup && IsGroup?.length > 0 && IsGroup[0] === propertyGrpName ?
                                                            propertWithGroup && propertWithGroup?.length > 0 && theGroup &&
                                                            <>
                                                              <span className="print_w-20"></span>
                                                              <span className=" mr-1 fk-print-text lg-text fk-print-text--bold print_w-80">
                                                                {/* {theGroup &&
                                                                  theGroup.name + " :"} */}
                                                                  {getTranlatedValue(`${theGroup && theGroup.name} :`, theGroup?.translated_name)}
                                                              </span>
                                                            </>
                                                              
                                                          }
                                                          {propertWithGroup && propertWithGroup?.map(
                                                            (
                                                              propertyName,
                                                              propertyIndex
                                                              ) => {
                                                                
                                                                if (
                                                                  printItem.properties &&
                                                                  parseInt(
                                                                    bracketReplace(propertyName.item.property_group_id)
                                                                    ) === theGroup?.id
                                                                  ) {
                                                                    return(
                                                                    <>
                                                                      <span className="print_w-20"></span>
                                                                      <span className="text-capitalize mr-1 fk-print-text lg-text fk-print-text--bold print_w-80" >
                                                                      {/* <span>
                                                                        ({printItem.quantity > 1 ?
                                                                          printItem.quantity * propertyName.quantity
                                                                          : propertyName.quantity
                                                                            }){" "}
                                                                      </span>
                                                                      {
                                                                        propertyName.item.name
                                                                      }{" "}
                                                                      {
                                                                        propertyIndex == propertWithGroup?.length - 1
                                                                        ? "." : ","} */}
                                                                        {getTranlatedValue(`(${printItem.quantity > 1 ? printItem.quantity * propertyName.quantity
                                                                          : propertyName.quantity}) ${propertyName.item.name} ${propertyIndex == propertWithGroup?.length - 1
                                                                            ? "." : ","}`, propertyName.item?.translated_name && `  ${propertyName.item?.translated_name}`)}
                                                                      </span>
                                                                    </>
                                                                    )
                                                                    
                                                                  }else {
                                                                    return true;
                                                                  }
                                                            })}
                                                          </>
                                                        );
                                                      }
                                                    )}
                                                    </div>
                                                ) : (
                                                  ""
                                                )
                                              }
                                            </>
                                            ) : (
                                              <>                                              
                                                <div className="d-flex flex-wrap align-items-center">
                                                  <span className="print_w-20 ml-1 pl-1">
                                                  {printItem.quantity * printItem.property.quantity}
                                                  </span>
                                                  <span className="text-preline text-break lg-text fk-print-text--bold fk-print-text print_w-80 p-0 m-0">
                                                    {printItem.property.item.name}{" "}
                                                  
                                                    <span className="lg-text fk-print-text--bold fk-print-text pl-1 ml-2" >
                                                      {printItem.comments ? `(${printItem.comments})` : ""}
                                                    </span>
                                                  </span>
                                                </div>
                                              </> 
                                             )
                                           }
                                          </th>
                                      </tr>
                                    );
                                  }
                                )}
                              </>
                            );
                          }
                        )}
                    </tbody>
                  </table>
                  <div className="myBorderBottom"></div>
                  <p className="my-1 fk-print-text text-capitalize lg-text fk-print-text--bold">
                    {_t(t("Date"))}: {" "} <Moment format="LL">{new Date()}</Moment>
                  </p>
                  <p className="my-0 fk-print-text text-capitalize lg-text fk-print-text--bold">
                    {_t(t("Time"))}: {" "}
                    {orderDetails?.token && (
                      <Moment format="LT">{new Date()}</Moment>
                    )}
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/*barcode print*/}
      <div id="barcode" className="d-none">
        {orderDetails?.branch && orderDetails.branch?.barcode_enable && barcodePrintRef && (
          <div ref={barcodePrintRef}>
            <div className="fk-print">
              <div className="container-fluid">
                <div className="row p-0">
                  {selectedKot && Object.keys(selectedKot)?.length &&
                    Object.keys(selectedKot).map((theGrp) => (
                      selectedKot[theGrp] && Object.keys(selectedKot[theGrp]).map((grp)=>(
                        selectedKot[theGrp][grp] && selectedKot[theGrp][grp]?.length && selectedKot[theGrp][grp].map((printItem, ind) => (
                            Array.from({ length: printItem.quantity || 0 }).map((_, i) => {
                              let value = "";
                              if(orderDetails.token?.id){
                                const orderNoEnabled= parseInt(getSystemSettings(generalSettings, "order_no")) === 1;
                                const sourceString = orderNoEnabled && orderDetails?.order_No
                                  ? String(orderDetails.order_No)
                                  : (String(orderDetails?.token?.id) ?? "");
                                const index = sourceString.lastIndexOf("-");
                                const token = index !== -1 ? sourceString.slice(index + 1) : sourceString;
                                value += token
                              }
                              if(printItem?.item){
                                value += "-" + printItem.item.id;
                                if(printItem?.variation){
                                  value += "." + printItem.variation?.variation_id
                                }
                                if(orderDetails.waiter?.id){
                                  value += "-"
                                }
                              }
                              if(orderDetails.waiter?.id){
                                value += orderDetails.waiter.id
                              }
                              value += "-" + i + 1;

                              if(!order_id || (!printItem?.reason && !printItem?.status)){
                                return (
                                  <div key={`${ind}-${i}`} className={`break-after-page col-6`}>
                                    <div className ="d-flex text-break align-items-center justify-content-between mx-1"> 
                                      <span className="fk-print-text text-uppercase font-weight-md sm-text mr-1">
                                        {(orderDetails?.token && orderDetails.token.id) ?? " - "}
                                      </span>
                                      {
                                        orderDetails.waiter?.name && (
                                          <span className="fk-print-text text-uppercase font-weight-md sm-text">
                                            {(orderDetails?.waiter && orderDetails.waiter?.name) ?? ""}
                                          </span>
                                        )
                                      }
                                    </div>
                                    <div className="fk-print-text w-100 text-center">
                                      <OrderBarcode value={value} text={printItem.item.name} height="15" width={0.7} />
                                    </div>
                                  </div>
                                )
                              }
                            })
                          )
                        )
                      ))
                    )
                  )}
                </div>  
              </div>
            </div>
          </div>
          )
        }
      </div>
    </>
  )
}
